export { default as useEmptyMaterialsSet } from './useEmptyMaterialsSet';
